<template>
  <sp-button
    class="sp-index-filters-activator"
    variant="flat"
    color="default"
    prepend-icon="settings-color"
    append-icon="triangle-down-filled"
    :data-testid="TestId.admin.indexFilters"
  >
    {{ t("filters") }}
    <span v-if="count" class="sp-index-filters-activator__count">{{ countLabel }}</span>
  </sp-button>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { t } from "#ce/apps/SpAdmin/SpIndexFilters/i18n";

const props = defineProps({ count: { type: Number, default: 0 } });

const countLabel = computed(() => t("applied_count", { count: props.count }));
</script>

<style scoped>
.sp-index-filters-activator {
  --sp-comp-button-bg-color: var(--sp-comp-admin-pill-menu-trigger-bg-color);
  --sp-comp-button-default-hover-bg-color: var(--sp-comp-admin-pill-menu-trigger-hover-bg-color);
  --sp-comp-button-text-color: var(--sp-comp-admin-pill-menu-trigger-text-color);
  --sp-comp-button-border-radius: var(--sp-comp-admin-pill-menu-trigger-border-radius);
  --sp-comp-button-focus-border-radius: var(--sp-comp-button-border-radius);
  --sp-comp-button-size: var(--sp-comp-admin-pill-menu-trigger-size);
  --sp-comp-button-padding: var(--sp-comp-admin-pill-menu-trigger-padding);
  --sp-comp-button-gap: var(--sp-comp-admin-pill-menu-trigger-gap);
  --sp-comp-button-font-short: var(--sp-comp-admin-pill-menu-trigger-font);
  --sp-comp-button-prepend-icon-size: var(--sp-comp-admin-pill-menu-trigger-prepend-icon-size);
}

.sp-index-filters-activator__count {
  margin-inline-start: var(--sp-comp-admin-pill-menu-trigger-count-gap);
}
</style>
